import './LabelColorBand.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

class LabelColorBand extends Component {
    render() {
        const { size, colors } = this.props;
        
        return (
            <div className={`LabelColorBandContainer _${size}`}>
                {colors.map(({ label, style }) => (<div key={label} className={'LabelColorBand'} style={{ ...style }}>{label}</div>))}
            </div>

        );
    }
}

LabelColorBand.defaultProps = {
    colors: []
};

LabelColorBand.propTypes = {
    colors: PropTypes.array,
    size: PropTypes.string.isRequired,
};

export default LabelColorBand;